export class ColorTheme {
  static readonly BLUE = '#0A31A2'
  /**
   * Light Grey
   */
  static readonly LIGHT_GREY = 'rgb(250, 250, 250)'
}